<template>
    <v-container id="who-we-are" class="pt-12 pb-16">
        <v-row>
            <v-col class="d-flex justify-center">
                <h2 class="text-h4 text-uppercase">Who We Are</h2>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="10" md="8">
                <p class="text-center">
                    Prospira is rooted in innovation and dedicated to
                    providing world-class anti-vibration products for the 
                    automotive industry that improves lives around the globe.
                </p>
            </v-col>
        </v-row>

        <v-row align="center" justify="center pb-2">
            <v-col cols="7" md="4">
                <v-hover v-slot="{ hover }">
                    <router-link to="/about-us" style="text-decoration: none;">
                        <v-card
                            :elevation="hover ? 12 : 2"
                            :class="{ 'on-hover': hover }"
                        >
                            <v-img
                                aspect-ratio="1"
                                src="@/assets/components/who-we-are/misc_parts_392x336.jpg"
                                class="img-card white--text align-end"
                                alt="Anti vibration parts"
                            >
                                <v-card-title>
                                    <p class="img-card__title">Anti Vibration Products</p>
                                </v-card-title>
                            </v-img>
                        </v-card>
                    </router-link>
                </v-hover>
            </v-col>

            <v-col cols="7" md="4">
                <v-hover v-slot="{ hover }">
                    <v-card
                        :elevation="hover ? 12 : 2"
                        :class="{ 'on-hover': hover }"
                        href="#quality"
                    >
                        <v-img
                            aspect-ratio="1"
                            src="@/assets/components/who-we-are/inspection_750x396.jpg"
                            class="img-card white--text align-end"
                            alt="Individual inspecting a work station"
                        >
                            <v-card-title>
                                <p class="img-card__title">Commitment to Quality</p>
                            </v-card-title>
                        </v-img>
                    </v-card>
                </v-hover>
            </v-col>

            <v-col cols="7" md="4">
                <v-hover v-slot="{ hover }">
                    <router-link to="/leadership" style="text-decoration: none;">
                        <v-card
                            :elevation="hover ? 12 : 2"
                            :class="{ 'on-hover': hover }"
                        >
                            <v-img
                                aspect-ratio="1"
                                src="@/assets/components/who-we-are/innovative_leaders_415x277.jpg"
                                class="img-card white--text align-end"
                                alt="Leader presenting to a room of people"
                            >
                                <v-card-title>
                                    <p class="img-card__title">Innovative Leaders</p>
                                </v-card-title>
                            </v-img>
                        </v-card>
                    </router-link>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'WhoWeAre',
}
</script>

<style scoped>
.v-card {
  transition: opacity .4s ease-in-out;
}

.v-card:not(.on-hover) {
    background-color: #141414;
    opacity: .7;
 }

.img-card:after {
    content: "";
    width: 100%;
    height: 100%;
    position: absolute;
}

.img-card__title {
    z-index: 999 !important;
    font-weight: bold;
}
</style>